module.exports = __webpack_public_path__ + "static/media/arrow-down-black.1145f54e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/arrow-down-black.svg
// module id = 148
// module chunks = 0